<template>
    <div>
        <a 
            @click="clickActive"
            class="text-xs uppercase py-3 font-bold block relative flex items-start"
            :class="[
                parentActive
                ? 'text-emerald-500 hover:text-emerald-600'
                : 'text-blueGray-700 hover:text-blueGray-500',
            ]"
            >
            <i
                class="fas fa-users mr-2 text-sm"
                :class="[parentActive ? 'opacity-75' : 'text-blueGray-300']"
            ></i>

            <div class="flex-1">
                <span class="block">
                {{ data.title }}
                </span>
            </div>

            <span 
                class="ml-2 flex items-center"
                :class="[
                isActive
                    ? 'icon active'
                    : 'icon',
                ]"
            >
                <img 
                style="width: 10px; height: auto;"
                :class="[
                    parentActive
                    ? 'activeIcon'
                    : '',
                ]"                        
                :src="DropDownNavIcon" 
                alt=""
                />
            </span>
        </a>
        <ul 
            v-if="isActive"
            class=''>
            <li 
                class="items-center nav-item relative item-children"
                v-for="(elem, ind) in data.childrens"
                :key="ind"
                >
                <router-link
                  :to="elem.link"
                  v-slot="{ href, navigate, isActive }"
                >
                    <a 
                        :href="href"
                        @click="navigate"
                        :class="[
                            isActive
                                ? 'text-emerald-500 hover:text-emerald-600'
                                : 'text-blueGray-700 hover:text-blueGray-500',
                        ]"
                        >
                        {{ elem.title  }}
                    </a>
                </router-link>
            </li>
        </ul>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import DropDownNavIcon from "@/assets/img/icons/arrow-down-sign-to-navigate.png";

export default {
    data() {
        return {
            DropDownNavIcon: DropDownNavIcon,
            parentActive: false,
            isActive: false,
        };
    },
    computed: mapState(['user']),
    mounted() {
        const elemLink = this.$props.data.link.split('/')[3]; 
        const routeLink = this.$route.fullPath.split('/')[3]; 
        if(elemLink == routeLink) {
            this.parentActive = true;
        }
    },
    methods: {
        clickActive() {
            this.isActive = !this.isActive;
        }
    },
    props: {
        data: {
            default: {},
        },
    },
    components: {},
};
</script>


<style></style>